// extracted by mini-css-extract-plugin
module.exports = {"root":"RedirectBanner_root___Y4df","completionText":"RedirectBanner_completionText__YxJbb"};